/**
 * Question helpers for the multiple-choice quiz stage, ported from
 * old/index.php -> old/game.php: questions live in the `questions` SQL table
 * (fetched via /listQuestions), each with its own 2-6 freeform options and a
 * 1-based `answer_id` pointing at the correct one.
 */

import { listQuestions } from "../../admin/functions/questionsApi";

const OPTION_KEYS = [
  "option_one",
  "option_two",
  "option_three",
  "option_four",
  "option_five",
  "option_six",
];

/** Raw SQL row -> { id, question_name, question_hint, options: [...], correctIndex }. */
export function normalizeQuizGameQuestion(row) {
  if (!row || typeof row !== "object") return null;
  const question_name = String(row.question_name ?? "").trim();
  if (!question_name) return null;

  const showOption = Math.max(2, Math.min(6, parseInt(row.showOption, 10) || 0));
  const options = OPTION_KEYS.slice(0, showOption)
    .map((key) => String(row[key] ?? "").trim())
    .filter(Boolean);
  if (options.length < 2) return null;

  const answerId = parseInt(row.answer_id, 10);
  const correctIndex =
    Number.isFinite(answerId) && answerId >= 1 && answerId <= options.length ? answerId : null;
  if (!correctIndex) return null;

  return {
    id: row.id,
    question_name,
    question_hint: String(row.question_hint ?? "").trim(),
    options,
    correctIndex,
    correctAnswer: options[correctIndex - 1],
  };
}

/** All playable questions for a theme (see old/game.php's `SELECT * FROM questions ...`). */
export async function fetchQuizGameQuestions({ themeName, organizationId, sessionId, token }) {
  const rows = await listQuestions({ themeName, organizationId, sessionId, token });
  return rows.map(normalizeQuizGameQuestion).filter(Boolean);
}

export function shuffleCopy(arr) {
  const next = arr.slice();
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const t = next[i];
    next[i] = next[j];
    next[j] = t;
  }
  return next;
}
